import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/GlobalState";
import { useAlert } from "react-alert";
import { useParams } from "react-router-dom";
const messages = [
  "Authenticating, please wait..",
  "Retrying, please wait..",
  "Error occured, please try again.. ",
  "Facing Difficulty while accessing local storage",
];

function isLocalStorageNameSupported() {
  var testKey = "test",
    storage = window.localStorage;
  try {
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    fetch(`${process.env.REACT_APP_TEST_ORIGIN_2}/api/v1/errorlogs`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        error: error,
      }),
    });
    return false;
  }
}

function Session() {
  const alert = useAlert();

  const { sessionId, userId } = useParams();
  const { setUserDetails } = useContext(GlobalContext);
  const [mssg, setMssg] = useState(0);

  const getUserDetails = async () => {
    try {
      window.localStorage.setItem("userId", userId);
      await fetch(
        `${process.env.REACT_APP_ORIGIN}/api/v1/auth/session-login?sessionId=${sessionId}&userId=${userId}`
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.status === "success") {
            const user = response.data.payload;
            setUserDetails({
              isAuthenticated: true,
              name: user.name,
              userId: user.userId,
              schoolId: user.school,
              role: user.role,
              selectedTab: "Dashboard",
              grades: user.grades || [],
            });

            window.localStorage.setItem("authToken", response.data.token);
            window.localStorage.setItem(
              "profileImageUrl",
              user.profile?.fileUrl
            );
            window.localStorage.setItem("language", "english");
            window.location.href = "/dashboard";
          } else if (response.status === "connecting") {
            if (mssg === 1) {
              setMssg(2);
            } else {
              setMssg(1);
              setTimeout(async () => getUserDetails(), 1000);
            }
          } else {
            setMssg(2);
            alert.show(response.message, { type: "error" });
            window.location.href = `${process.env.REACT_APP_REDIRECT}?logout=true`
            window.localStorage.clear();
          }
        });
    } catch (error) {
      setMssg(2);
      window.location.href = `${process.env.REACT_APP_REDIRECT}?logout=true`;
      window.localStorage.clear();
    }
  };

  useEffect(() => {
    getUserDetails();
    if (isLocalStorageNameSupported()) {
    } else {
      setMssg(3);
    }
  }, [setMssg]);

  return (
    <div style={{ textAlign: "center" }}>
      <p style={{ marginTop: "2rem", fontFamily: "Poppins" }}>
        {messages[mssg]}
      </p>
    </div>
  );
}

export default Session;
